import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Header from "./Component/Views/Layout/Header";
import Footer from "./Component/Views/Layout/Footer";
import Home from "./Component/Views/Home/Home";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Component/Assets/Css/custom.css";
import "./Component/Assets/Css/responsive.css";
import { ToastContainer } from "react-toastify";
function App() {
  const location = useLocation();
  const [showHeaderFooter, setShowHeaderFooter] = useState(true);
  useEffect(() => {
    setShowHeaderFooter(
      location.pathname !== "/buy" && location.pathname !== "/dashboard-staking"
    );
  }, [location]);
  useEffect(() => {
    AOS.init({
      disable: window.innerWidth < 991,
    });
  }, []);
  return (
    <>
      {showHeaderFooter && <Header />}
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
      {showHeaderFooter && <Footer />}
    </>
  );
}
function AppWithRouter() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

export default AppWithRouter;
